import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { ActivityCodeEnum, PurposeEnum } from 'src/app/models/shared-models';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';
import { IActivityStorageDataModel, IPurposeDataModel, IPurposeModel, IReasonModel } from '../models/veg-wizard-models';
import { Logger } from './logger-service';

@Injectable({
  providedIn: 'root'
})
export class ReasonService {

  constructor(private http: HttpClient,
    private sessionService: SessionService,
    private logger: Logger) {
  }

  setReason$(model: IReasonModel[]): Observable<boolean> {
    const sessionId = this.sessionService.getSessionId();
    const url = `${environment.apiUrl}/session/set-reason`;
    return this.http.post(url, { sessionKey: sessionId, Reasons: model })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.logger.error('setReason error', err);
          return of(false)
        }),
        map(() => true) // return true, as it should be HttpStatusCode OK
      );
  }

  getReasonExampleLabelInformation(purpose: IPurposeModel | undefined, activities: IActivityStorageDataModel | undefined): string {
    let reasonExampleInformation = '';

    if (!!purpose && purpose !== null) {
      const purposeCode = purpose.purposeCode;

      switch (purposeCode) {
        case PurposeEnum.coordinatedProjects:
          reasonExampleInformation = 'What is the name of coordinated project?';
          break;
        case PurposeEnum.publicSafety:
          reasonExampleInformation = 'Please specify the public safety risk';
          break;
        case PurposeEnum.weedControl:
          reasonExampleInformation = 'What is the reason for clearing? e.g. Lantana (Lantana camara)';
          break;
        case PurposeEnum.managingWeeds:
          reasonExampleInformation = 'Please identify the target weed species';
          break;
        case PurposeEnum.nativeForestPractice:
            reasonExampleInformation = 'Please identify the forest product/s to be produced or reason for undertaking the clearing.';
            break;          
        case PurposeEnum.infrastructure:
          if (activities) {
            let activityCodes = activities?.selectedActivities?.map(a => a.activityCode);
            activityCodes = [...new Set(activityCodes)]; // filter to unique only

            if (activityCodes.length == 1) {
              const activityCode = activityCodes[0];

              if (activityCode == ActivityCodeEnum.otherLinearInfrastructure) {
                reasonExampleInformation = 'Please enter a reason for the clearing (e.g. pipeline):';
              }
              if (activityCode == ActivityCodeEnum.otherNonLinearInfrastructure) {
                reasonExampleInformation = 'Please enter a reason for the clearing (e.g. shed):';
              }
            }
          }
          break;
        default:
          reasonExampleInformation = 'Please specify the forest product?';
          break;
      }
    }

    return reasonExampleInformation;
  }
}
